<div class="maintenances_graph">
  <div class="graph_donut">
    <donut [globalValue]="totalMaintenanceTodo" [values]="donutValues"></donut>
    <ubi-title [level]="3" style="padding: 0">{{ 'MISSION.DISTRIBUTION' | translate }}</ubi-title>
  </div>
  <div class="graph_states">
    @for (key of statesMaintenances; track trackStatus($index, key)) {
      @if (key !== 3) {
        <status-card
          [label]="statesMaintenancesGraph[key].label | translate"
          [color]="colorsStates[key]"
          [value]="statesMaintenancesGraph[key].count"
          [percentage]="statesMaintenancesGraph[key].percent * 100"></status-card>
      }
    }
  </div>
</div>
